import { template as template_75d6866c99134af698732395ad07440f } from "@ember/template-compiler";
import { fn } from '@ember/helper';
import Component from '@glimmer/component';
import Message from 'ember-simplepractice/components/spds/feedback/alert-banner/message';
import pht from 'client-portal/utils/persistent-hash-table';
import styles from './rejected-requests.module.scss';
export default class SiteBillingInsuranceRejectedRequests extends Component {
    styles = styles;
    dismissRequest = (id)=>{
        pht.set(`rejected-insurance-request-${id}`, true);
    };
    #isDismissed = (id)=>{
        return pht.get(`rejected-insurance-request-${id}`);
    };
    get notDismissedRequests() {
        return this.args.rejectedInsuranceRequests.filter((request)=>!this.#isDismissed(request.id));
    }
    static{
        template_75d6866c99134af698732395ad07440f(`
    <div class={{styles.component}}>
      {{#each this.notDismissedRequests as |request|}}
        <Message
          @type="warning"
          @includeIcon={{true}}
          @onClose={{fn this.dismissRequest request.id}}
          data-test-rejected-insurance-request={{request.id}}
        >
          <:header>
            Insurance info upload declined
          </:header>
          <:body>
            Your upload of
            {{request.insuranceInfoRequestConnection.insurancePlan.nameWithPayer}}
            was declined by the practice. If you believe this is an error reach out to your
            clinician for more details.
          </:body>
        </Message>
      {{/each}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
